import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { FraudReportReferenceData } from "@idw-types/state/fraud-report-state";

export const getAssertionFraudReferenceDataRequest = async (): Promise<{ data: FraudReportReferenceData, error: any }> => {
    const route = apiRoutes.reports.assertionFraud.referenceData;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};